import { IGetReportTreinamentoFuncionarioUseCase } from "../../../presentation/useCases/read/get_report_treinamento_funcionario_use_case";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";
import { IGetReportPlanoAuditoriaUseCase } from "../../../presentation/useCases/read/get_report_plano_auditoria_use_case";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

//GetReportPlanoAuditoriaUseCase
export class GetReportPlanoAuditoriaUseCase implements IGetReportPlanoAuditoriaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportPlanoAuditoria(IdAuditoria: number, requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportPlanoAuditoria(IdAuditoria, requiredMimeType);

  if (requiredMimeType !== "text/html") {
        const date = new Date().toISOString();
        const arquivoData = response.bytes;
        const arquivoNome =
          `plano_Auditoria_${date}.${response.filenameExtension}`;
  
        await downloadBase64File(arquivoNome, arquivoData);
      }
  
      return response;
  }
}
